import { FileUpload, FileUploadUploadEvent } from 'primereact/fileupload'
import React from 'react'
import { ImageType } from 'types/Image'

import { Container } from './customFileUpload.style'

interface Props {
    onUpload: (event: FileUploadUploadEvent) => void
    setImageOptions: React.Dispatch<React.SetStateAction<ImageType[]>>
    allowMultiple?: boolean
}

export const CustomFileUpload = ({ onUpload, setImageOptions, allowMultiple = true }: Props) => {
    const handleUpload = (event: FileUploadUploadEvent) => {
        try {
            const { files } = event
            const response = event.xhr.responseText
            const jsonResponse = JSON.parse(response)

            const imageIds: string[] = jsonResponse.images.map((current: ImageType) => {
                return current.image_id
            })

            const newlyUploadedImages: ImageType[] = files.map((file, index) => ({
                image_id: imageIds[index],
                image_url: URL.createObjectURL(file),
            }))
            setImageOptions((prevImages) => [...prevImages, ...newlyUploadedImages])

            if (onUpload) {
                onUpload(event)
            }
        } catch (e) {
            console.error('Failed to handle upload:', e)
        }
    }

    return (
        <Container>
            <FileUpload
                auto
                className="fileupload"
                name="images"
                url="/api/v1/images/upload"
                multiple={allowMultiple}
                accept="image/*"
                maxFileSize={3000000}
                emptyTemplate={<p className="m-0">Drag and drop files here to upload.</p>}
                onUpload={handleUpload}
                previewWidth={50}
                chooseLabel="Kiválasztás"
                removeIcon={<></>}
            />
        </Container>
    )
}
